<template>
  <div class="site-footer">
    <Container>

      <div class="links">
        <a href="/">
          <i class="fab fa-twitter"></i>
        </a>
        <a href="/">
          <i class="fab fa-discord"></i>
        </a>
        <a href="/">
          <i class="fab fa-medium"></i>
        </a>
        <a href="/">
          <i class="fab fa-reddit"></i>
        </a>

      </div>

    </Container>
  </div>
</template>

<script>

export default {
  name: 'siteFooter',
  components: {},
  props: [],
  data() {
    return {
      
    }
  },
  computed: {},
  watch: {},
  methods: {
    
  },
  created() {
    
  },
  //mounted() {},
  //beforeDestroy() {},
  //update() {},
  //activited() {},
  //beforeRouteUpdate() {},
  //filters: {},
};
</script>

<style lang="scss" scoped>
  .site-footer{
    width: 100%;

    .links{
      text-align: center;
      font-size: 28px;
      a{
        margin: 15px;
      }
    }

  }
</style>